// TODO: Fix this auto-generated suppression.
// eslint-disable-next-line rulesdir/deprecate-formik
import { FormikContextType } from 'formik'
import { FC } from 'react'
import styled from 'styled-components'

import { OptionCheckbox as LMFOptionCheckbox, TypeStyle } from '@syconium/little-miss-figgy'

import { useTranslation } from '../../../../../app/_providers/TranslationProvider.client'
import { DTCLogoSetupFormValues } from '../../../../../containers/EmbroideryService/types'
import { ErrorMessage } from '../../shared-form-styles'
import { LogoFormContainer } from '../LogoFormContainer'

interface Props {
  form: Pick<FormikContextType<DTCLogoSetupFormValues>, 'errors' | 'getFieldProps'>
}

export const TosCheckbox: FC<Props> = ({ form }) => {
  const name = 'tos'
  const {
    embroidery: {
      modal: {
        forms: {
          dtcLogoEmbroideryForm: { termsOfServiceNoLinks },
        },
      },
    },
  } = useTranslation()
  const { logoSetupForm } = LogoFormContainer.useContainer()
  return (
    <OptionCheckbox
      name={name}
      type='checkbox'
      value='yes'
      onChange={logoSetupForm.handleChange}
      checked={(logoSetupForm.values.tos && logoSetupForm.values.tos[0]?.includes('yes')) ?? false}
    >
      <TermsOfService>{termsOfServiceNoLinks}</TermsOfService>
      {form.errors[name] && (
        <ErrorMessage inset role='alert'>
          {form.errors[name]}
        </ErrorMessage>
      )}
    </OptionCheckbox>
  )
}

const OptionCheckbox = styled(LMFOptionCheckbox)`
  margin: ${props => props.theme.spacing(6)} 0 ${props => props.theme.spacing(6)} 0;
  padding: 0;
`

const TermsOfService = styled(TypeStyle.HeadlineMicro)`
  line-height: 20px;
`
